import traits from './traits.json';
import { Trait } from './trait';

type TraitsData = {
  [key: string]: Trait[];
};

export const shuffledIndexes: { [key: string]: number[] } = {
  centralPiece: [
    5, 15, 18, 6, 17, 20, 8, 19, 0, 2, 12, 11, 10, 9, 4, 7, 1, 13, 3, 16, 14
  ],
  clock: [7, 4, 3, 5, 6, 1, 2, 0, 8],
  planetaryClock: [2, 0, 1],
  gyroscope: [2, 3, 8, 7, 0, 5, 1, 6, 4],
  runes: [2, 1, 0],
  rewardProgram: [1, 2, 0],
  gems: [1, 0, 2],
  frame: [2, 0, 1],
  cogwheels: [0, 1, 2],
  multiplier: [2, 0, 1],
  shell: [19, 7, 13, 0, 1, 17, 14, 3, 6, 18, 11, 16, 15, 8, 10, 9, 2, 4, 5, 12],
  glass: [1, 0],
  star: [16, 7, 3, 14, 8, 19, 13, 17, 12, 1, 0, 6, 9, 10, 15, 11, 2, 18, 4, 5],
  magicCircle: [1, 2, 0, 3, 4, 8, 5, 7, 6]
};

export function generateRandomRange(range: number) {
  let i: number = 0;
  let randomNumber;
  let randomRange: number[] = [];
  for (i = 0; i < range; i++) {
    randomNumber = Math.random();
    randomRange.push(randomNumber);
  }
  return randomRange;
}

export function getRandomRanges() {
  let shuffledTraits = new Map();
  const traitsData: TraitsData = traits;
  for (let piece in traitsData) {
    const range = generateRandomRange(traitsData[piece].length);

    let rangeMap: any = [];
    let i = 0;
    range.forEach((number) => {
      rangeMap.push({ index: i, randomNumber: number });
      i++;
    });

    rangeMap.sort((a: any, b: any) => {
      return a['randomNumber'] - b['randomNumber'];
    });

    const randomIndexes: number[] = [];
    rangeMap.forEach((obj: any) => {
      randomIndexes.push(obj['index']);
    });

    shuffledTraits.set(piece, randomIndexes);
    console.log(piece, randomIndexes);
  }
  console.log(shuffledTraits);
}
